import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './Abstracto';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import 'animate.css/animate.min.css';

const history = createBrowserHistory();

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
